const getters = {
	language: state => state.app.language,
	loggedIn: state => state.app.token && state.app.confirmed,
	token: state => state.app.token,
	isMobileDevice: state => state.app.device == 'mobile'
}

export default getters
